<template>
  <nav class="wizard-stepper mb-4 mb-lg-5 flex-shrink-0" :aria-label="ariaLabel">
    <ol class="wizard-stepper__list list-unstyled d-flex align-items-center justify-content-center mb-0">
      <li
        v-for="(stepItem, index) in normalizedSteps"
        :key="index"
        class="wizard-stepper__item d-flex align-items-center"
        :class="{
          'wizard-stepper__item--active': step === index,
          'wizard-stepper__item--done': step > index,
          'wizard-stepper__item--disabled': !isStepReachable(index)
        }"
      >
        <button
          type="button"
          class="wizard-stepper__btn btn btn-link p-0 text-decoration-none d-flex align-items-center gap-2"
          :disabled="disabled || !isStepReachable(index)"
          @click="onStepClick(index)"
        >
          <span class="wizard-stepper__number">{{ index + 1 }}</span>
          <span class="wizard-stepper__label d-none d-sm-inline fs-7 fw-semibold">{{ stepItem.title }}</span>
          <span class="wizard-stepper__label d-sm-none fs-7 fw-semibold">{{ stepItem.short }}</span>
        </button>
        <span
          v-if="index < normalizedSteps.length - 1"
          class="wizard-stepper__connector"
          aria-hidden="true"
        />
      </li>
    </ol>
  </nav>
</template>

<script>
export default {
  name: 'WizardStepper',
  props: {
    step: {
      type: Number,
      required: true
    },
    steps: {
      type: Array,
      required: true,
      validator(steps) {
        return steps.length > 0
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    ariaLabel: {
      type: String,
      default: 'Шаги оформления'
    },
    stepReachable: {
      type: Function,
      default: null
    }
  },
  emits: ['update:step', 'step-click'],
  computed: {
    normalizedSteps() {
      return this.steps.map((stepItem) => {
        if (typeof stepItem === 'string') {
          return { title: stepItem, short: stepItem }
        }

        return {
          title: stepItem.title,
          short: stepItem.short ?? stepItem.title
        }
      })
    }
  },
  methods: {
    isStepReachable(index) {
      if (typeof this.stepReachable === 'function') {
        return this.stepReachable(index)
      }

      return index <= this.step
    },
    onStepClick(index) {
      if (this.disabled || index === this.step || !this.isStepReachable(index)) {
        return
      }

      this.$emit('step-click', index)
      this.$emit('update:step', index)
    }
  }
}
</script>

<style scoped>
.wizard-stepper {
  width: 100%;
  max-width: 42rem;
  margin-left: auto;
  margin-right: auto;
}

.wizard-stepper__list {
  width: 100%;
}

.wizard-stepper__item {
  flex: 0 0 auto;
}

.wizard-stepper__btn {
  color: var(--bs-gray-600, #7e8299);
  cursor: pointer;
}

.wizard-stepper__btn:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.wizard-stepper__number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  border: 2px solid var(--bs-gray-300, #e4e6ef);
  background: #fff;
  font-size: 0.875rem;
  font-weight: 600;
  flex-shrink: 0;
  transition: border-color 0.15s, background-color 0.15s, color 0.15s;
}

.wizard-stepper__item--active .wizard-stepper__number {
  border-color: var(--bs-primary, #009ef7);
  background: var(--bs-primary, #009ef7);
  color: #fff;
}

.wizard-stepper__item--active .wizard-stepper__label {
  color: var(--bs-gray-800, #181c32);
}

.wizard-stepper__item--done .wizard-stepper__number {
  border-color: var(--bs-primary, #009ef7);
  color: var(--bs-primary, #009ef7);
}

.wizard-stepper__item--disabled .wizard-stepper__btn {
  pointer-events: none;
}

.wizard-stepper__connector {
  display: inline-block;
  width: 2.5rem;
  height: 2px;
  margin: 0 0.5rem;
  background: var(--bs-gray-300, #e4e6ef);
  flex-shrink: 0;
}

.wizard-stepper__item--done .wizard-stepper__connector,
.wizard-stepper__item--active .wizard-stepper__connector {
  background: var(--bs-primary, #009ef7);
}

@media (min-width: 576px) {
  .wizard-stepper__connector {
    width: 4rem;
  }
}

@media (max-width: 575.98px) {
  .wizard-stepper__connector {
    width: 1.25rem;
    margin: 0 0.25rem;
  }
}
</style>
